import React from 'react';
import { IoMdCheckmark } from "react-icons/io";

const DetailsItems = () => {
  return (
    <>
      <div className="col-lg-3 col-md-4">
        <div className="item">
          <div className="ok-icon">
            <IoMdCheckmark />
          </div>
          <div className="content">
            <strong>For every project we commit to, we deliver.</strong>
            <p>
              By devoting our time to get to know you and your company, we want
              to know what it feels like to be your customer’s shoes.
            </p>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-4">
        <div className="item">
          <div className="ok-icon">
            <IoMdCheckmark />
          </div>
          <div className="content">
            <strong>
              We tell you how we run{' '}
              <a
                href="https://scrumguides.org/scrum-guide.html"
                className="a-link"
              >
                Scrum
              </a>{' '}
              and which tools we use to do it efficiently.
            </strong>
            <p>
              You’ll learn how we make sure everyone on the team is on the same
              page and shares the same goal.
            </p>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-4">
        <div className="item">
          <div className="ok-icon">
            <IoMdCheckmark />
          </div>
          <div className="content">
            <strong>
              After we convey the project to you, we don’t call it quits.
            </strong>
            <p>
              We are dedicated to creating great software with you and our team.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsItems;
